"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCount = exports.FilterSeparator = exports.FilterTitle = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importStar(require("styled-components"));
exports.FilterTitle = styled_components_1.default.h2 `
	color: ${({ theme }) => theme.color.brand1};
	font-size: 1rem;

	${({ noMargin }) => !noMargin &&
    (0, styled_components_1.css) `
			margin-top: 2rem;
		`}
`;
exports.FilterSeparator = (0, styled_components_1.default)(elements_1.Separator) `
	margin: 0.5rem 0 1rem;
`;
exports.FilterCount = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.gray5}; ;
`;
